
const itunesPodcastLookupUrl = (itunesId: string, limit = 1) => `https://itunes.apple.com/lookup?id=${itunesId}&entity=podcastEpisode&limit=${limit}`

export const searchItunes = async (term: string) => {
  try {
    const res = await fetch(`https://itunes.apple.com/search?term=${encodeURIComponent(term)}&limit=10&media=podcast`);
    const { results } = await res.json() as any;
    return results;
  } catch (e) {
    console.error(`[ERROR] Error searching for podcast: ${e.message}`);
    return [];
  }
};

export const fetchShow = async (itunesId: string) => {
  try {
    const res = await fetch(itunesPodcastLookupUrl(itunesId));
    const { results } = await res.json() as any;
    const collection = results[0];
    return {
      title: collection.collectionName,
      artworkUrl600: collection.artworkUrl600,
    }
  } catch (e) {
    console.error(`[ERROR] Error fetching for podcast: ${e.message}`);
    return {};
  }
}